import { useLocation } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { useNavigate } from "react-router-dom";

/**
 * ViewPan component displays user-entered and PAN-verified details for review.
 * Provides navigation and formatted display of PAN information.
 */
const ViewPan = ({ login = null }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const panDetails = location.state?.panDetails || {};
  function formatKey(key) {
    // Split the key by underscores, capitalize each part, and join with spaces
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 pancard-data">
            <div className="text-center mb-7">
              <img
                width="100"
                alt="icon"
                src={toAbsoluteUrl("/media/images/pan-check.png")}
              />
              <h6 className="mt-5">PAN is Valid</h6>
            </div>

            <div className="px-5">
              <h4 className="mb-5">Details Entered As Per You</h4>
              <label>PAN Card Number</label>
              <p>{panDetails?.pan}</p>
            </div>

            <div className="card_data">
              <h6>Details As Per The PAN Card</h6>
              <div className="d-flex justify-content-between flex-wrap">
                {Object.entries(panDetails).map(
                  ([key, value]) =>
                    value && ( // Check if value is truthy
                      <div key={key} className="details_card">
                        <label>{formatKey(key)}:</label>{" "}
                        <p>{value}</p>
                      </div>
                    )
                )}
              </div>
            </div>

            <div className="btns cn-btn mt-15 d-flex">
              {/* <Link to={`${redirectUrl}/pan-card/${userId}`}> */}
              <button className="btn bgdark-blue text-white" onClick={() => navigate(-1)}>Back</button>
              {/* </Link> */}

              {/* <Link to={`${redirectUrl}/pancard-uploded/${userId}`}>
              <button className="btn red-btn text-white">Submit</button>
            </Link> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewPan